import { render, staticRenderFns } from "./item_list.vue?vue&type=template&id=e71e7e50&scoped=true"
import script from "./item_list.vue?vue&type=script&lang=js"
export * from "./item_list.vue?vue&type=script&lang=js"
import style0 from "./item_list.vue?vue&type=style&index=0&id=e71e7e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71e7e50",
  null
  
)

export default component.exports